import { Badge, List, ListItem, ListItemText } from "@mui/material";
import { Button } from "components/Button/Button";
import ModalBox from "components/modal/ModalBox";
import React, { memo, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const MappedCityWiseCenters = ({
    open,
    onClose,
    linkSelectedId,
    assignStatus = {},
    galleryImage = [],
    centerListing,
}) => {
    const [galleryModal, setGalleryModal] = useState(false);

    return (
        <>
            <ModalBox
                size={"sm"}
                status={open}
                onClose={onClose}
                closeIcon
                custom
                customizedFooter={<div></div>}
            >
                <div className="form-group mt-1 row">
                    <div className="col-12">
                        <List>
                            <ListItem
                                secondaryAction={
                                    <Badge
                                        color="success"
                                        className="mui-badge"
                                        badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                                        invisible={!assignStatus.course}
                                    >
                                        <Button
                                            size="small"
                                            to={`/city-pages/billing-course-mapping/${linkSelectedId}`}
                                            type="acl"
                                            role={850002}
                                        >
                                            Link
                                        </Button>
                                    </Badge>
                                }
                            >
                                <ListItemText primary="Billing Courses" />
                            </ListItem>
                            <ListItem
                                secondaryAction={
                                    <Badge
                                        color="success"
                                        className="mui-badge"
                                        badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                                        invisible={!assignStatus.video}
                                    >
                                        <Button
                                            to={`/city-pages/link-intro-video/${linkSelectedId}`}
                                            size="small"
                                            type="acl"
                                            role={850002}
                                        >
                                            Link
                                        </Button>
                                    </Badge>
                                }
                            >
                                <ListItemText primary="Center Introduction Video" />

                            </ListItem>
                            {/* <ListItem
                                secondaryAction={
                                    <Badge
                                        color="success"
                                        className="mui-badge"
                                        badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                                        invisible={!assignStatus.news}
                                    >
                                        <Button
                                            to={`/city-pages/link-news/${linkSelectedId}`}
                                            size="small"
                                            type="acl"
                                            role={850002}
                                        >
                                            Link
                                        </Button>
                                    </Badge>
                                }
                            >
                                <ListItemText primary="News" />

                            </ListItem> */}
                            <ListItem
                                secondaryAction={
                                    <Badge
                                        color="success"
                                        className="mui-badge"
                                        badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                                        invisible={!assignStatus.subheading}
                                    >
                                        <Button
                                            to={`/city-pages/link-sub-heading/${linkSelectedId}`}
                                            size="small"
                                            type="acl"
                                            role={850002}
                                        >
                                            Link
                                        </Button>
                                    </Badge>
                                }
                            >
                                <ListItemText primary="Sub-Heading" />

                            </ListItem>
                            {/* <ListItem
                secondaryAction={
                  <Badge
                    color="success"
                    className="mui-badge"
                    badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                    invisible={!assignStatus.faq}
                  >
                    <Button
                      size="small"
                      to={`faq-mapping/${linkSelectedId}`}
                      type="acl"
                      role={170008}
                    >
                      Link
                    </Button>
                  </Badge>
                }
              >
                <ListItemText primary="FAQs" />
              </ListItem>
              <ListItem
                secondaryAction={
                  <Badge
                    color="success"
                    className="mui-badge"
                    badgeContent={<CheckCircleIcon sx={{ fontSize: 20 }} />}
                    invisible={!assignStatus.image}
                  >
                    <Button
                      size="small"
                      onClick={() => setGalleryModal(true)}
                      type="acl"
                      role={170009}
                    >
                      Link
                    </Button>
                  </Badge>
                }
              >
                <ListItemText primary="Gallery" />
              </ListItem> */}
                        </List>
                    </div>
                </div>
            </ModalBox>

            {/* Upload Image Modal */}
            {/* <GalleryModal
        open={galleryModal}
        onClose={() => setGalleryModal(false)}
        closeMainModal={() => onClose()}
        centerId={linkSelectedId}
        galleryImage={galleryImage}
        centerListing={centerListing}
      /> */}
        </>
    );
};

export default memo(MappedCityWiseCenters);
